import { HookReadMoreActions } from './read-more';
import { sendDataToGa4 } from './ga4-push-to-gtm';
import { convertNameToId } from "./ga4";

/**
 * Display "read more" on desktop if text is long
 */
function DesktopReadMore() {

    const trainerDesc = document.querySelector( '.trainer-description' );
    const switchBtn = document.querySelector( '.mobile-read-more-switch' );

    if ( ! trainerDesc || ! switchBtn ) {
        return;
    }

    if ( window.innerWidth < 768 || screen.width < 768 ) {
        return;
    }

    const column = document.querySelector( '.heading-section__left-column' );
    const height = column.offsetHeight;

    if ( height < 350 ) {
       trainerDesc.classList.remove( 'mobile-read-more' );
       switchBtn.style.display = 'none';
    } else {
        trainerDesc.classList.add( 'mobile-read-more--trainer' );
    }

}

/**
 * Get data from url and send event to GTM
 */
function getEventDataForGA() {

    const url = new URL( window.location.href );
    const type = url.searchParams.get( 'typ' );
    const expertName = document.querySelector( 'h1.wp-block-heading' ).textContent;

    let listName = `Strona: ${expertName}`;

    if ( type === 'szkolenia_online' ) {
        listName = `Strona: ${expertName} - Szkolenia`;
    }

    if ( type === 'live_meetingi' ) {
        listName = `Strona: ${expertName} - Live Meetingi`;
    }

    let listId = convertNameToId(listName);

    const storage = sessionStorage.getItem( listName );

    const dataForGA = {
        event: 'view_item_list',
        item_list_name: listName,
        item_list_id: listId,
        ecommerce: {                         
          items: []
        }
    }

    if ( storage !== 'item-list-viewed' ) {
        sendDataToGa4( dataForGA );
    }

    sessionStorage.setItem( listName, 'item-list-viewed' );
}

/**
 * Get data when user scrolled to the element
 */
const observer = new IntersectionObserver( ( entries ) => {

    const eventsSection = entries[0];

    if ( eventsSection.isIntersecting ) {

        getEventDataForGA();
    }

} );

/**
 * Check if user scrolled to the element
 */
const observeUpcomingEvents = () => {

	const eventsSection = document.querySelector( '.kb-main-courses' );

    if ( eventsSection ) {
        observer.observe( eventsSection );
    }
	
}

window.addEventListener( 'DOMContentLoaded', () => {
    observeUpcomingEvents();
    HookReadMoreActions( 'trainer' );
    DesktopReadMore();
})
